import { TextManager } from "Components/TextContext";
import { isChild, isInfant } from "Utils/ageUtils";
import { reverseAndPadDDMMYYYY } from "Utils/dateUtils";
import { isAfter, isValid, subYears } from "date-fns";
import { AKA_CHILD_MAX_AGE } from "./akaChildConstants";

export const isNotChildError = (childBirthDate?: string): string => {
  const { getText } = TextManager;
  const birthDate = new Date(reverseAndPadDDMMYYYY(childBirthDate));
  if (isValid(birthDate)) {
    if (isInfant(birthDate)) {
      return getText("akachildform.validation.childbirthdate_infant");
    }
    if (!isChild(birthDate, AKA_CHILD_MAX_AGE)) {
      return getText("akachildform.validation.childbirthdate_adult");
    }
  }
  return "";
};

export const isAkaChild = (childBirthDate: Date): boolean =>
  isAfter(childBirthDate, subYears(new Date(), AKA_CHILD_MAX_AGE));
